var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-box',{class:(_vm.name + "__tip-box"),attrs:{"text":_vm.$t('module_dpa_ad_targeting_binding_hint'),"link-text":_vm.$t('module_dpa_ad_target_binding_link_text'),"linkUrl":_vm.linkUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }